<template>
  <bita-modal
    id="change-password"
    :title="title"
    :modal-md="true"
    @close="reset"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <!-- رمزعبور فعلی -->
            <div :class="colWidth" class="password-input-wrapper">
              <bita-input
                :type="showOldPassword ? 'text' : 'password'"
                name="old_password"
                label="رمزعبور"
                rules="required"
                :validation-container-class="colWidth"
                input-class="form-control k-password-input"
                v-model="formData.old_password"
              />
              <span class="password-toggle-wrapper" @click="showOldPassword = !showOldPassword">
                <svg v-if="showOldPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94L6.06 6.06"/>
                  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              </span>
            </div>

            <!-- رمزعبور جدید -->
            <div :class="colWidth" class="password-input-wrapper">
              <bita-input
                :type="showNewPassword ? 'text' : 'password'"
                name="password"
                label="رمزعبور جدید"
                rules="required"
                :validation-container-class="colWidth"
                input-class="form-control k-password-input"
                v-model="formData.password"
              />
              <span class="password-toggle-wrapper" @click="showNewPassword = !showNewPassword">
                <svg v-if="showNewPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94L6.06 6.06"/>
                  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              </span>
            </div>

            <!-- تکرار رمزعبور جدید -->
            <div :class="colWidth" class="password-input-wrapper">
              <bita-input
                :type="showConfirmPassword ? 'text' : 'password'"
                name="password_confirmation"
                label="تکرار رمزعبور جدید"
                rules="required"
                :validation-container-class="colWidth"
                input-class="form-control k-password-input"
                v-model="formData.password_confirmation"
              />
              <span class="password-toggle-wrapper" @click="showConfirmPassword = !showConfirmPassword">
                <svg v-if="showConfirmPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94L6.06 6.06"/>
                  <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              </span>
            </div>
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton
        v-if="!isLoading"
        type="primary"
        title="ذخیره"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="changePasswordH"
      />
      <bita-spinner
        v-show="isLoading"
        :is-loading="isLoading"
        styleName="align-self: center; display: inline-block; width: 200px"
      />
    </div>
  </bita-modal>
</template>

<script>
import { userApi } from "@/api/apiManagement";

export default {
  props: { title: String },
  data() {
    return {
      colWidth: "col-12",
      formData: { old_password: "", password: "", password_confirmation: "" },
      isLoading: false,
      showOldPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
    };
  },
  methods: {
    changePasswordH() {
      this.isLoading = true;
      userApi
        .changePassword(this.formData)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);
          this.$toggleModal("#change-password");
          this.$root.$emit("app:logout");
          this.$store.dispatch("logout");
          this.$router.push("/login");
        })
        .catch(() => {})
        .finally(() => { this.isLoading = false; });
    },
    reset() {
      this.formData = { old_password: "", password: "", password_confirmation: "" };
      this.showOldPassword = false;
      this.showNewPassword = false;
      this.showConfirmPassword = false;
      if (this.$refs.form) this.$refs.form.reset();
    },
    setErrors(_errors) {
      if (this.$refs.form) this.$refs.form.setErrors(_errors);
    },
  },
};
</script>

<style scoped>
.password-input-wrapper { 
  position: relative; 
  margin-bottom: 1rem; 
}

.password-toggle-wrapper {
  position: absolute; 
  top: 56%; 
  right: 30px; 
  transform: translateY(-50%);
  cursor: pointer; 
  display: flex; 
  align-items: center; 
  justify-content: center;
  width: 32px; 
  height: 32px; 
  z-index: 1000;
}

.password-toggle-wrapper svg { 
  width: 18px; 
  height: 18px; 
  stroke: #6c757d; 
  transition: stroke 0.2s; 
}

.password-toggle-wrapper:hover svg { 
  stroke: #575b5f; 
}
</style>

<style>

body #change-password .password-input-wrapper input,
body #change-password .k-password-input,
body #change-password .form-control.k-password-input,
body #change-password input[type="password"].k-password-input,
body #change-password input[type="text"].k-password-input {
  text-align: right !important;
  padding-right: 30px !important;
  padding-left: 50px !important;
  direction: rtl !important;
}

/* روی خود input داخل wrapper */
body #change-password .password-input-wrapper .k-password-input input,
body #change-password .password-input-wrapper input.form-control {
  text-align: right !important;
  padding-right: 30px !important;
  padding-left: 50px !important;
}

/* یا همه inputهای داخل modal */
#change-password input {
  text-align: right !important;
  padding-right: 30px !important;
  padding-left: 50px !important;
}
</style>
